import { render, staticRenderFns } from "./Diagnosis.vue?vue&type=template&id=64eebe36&scoped=true&"
import script from "./Diagnosis.vue?vue&type=script&lang=js&"
export * from "./Diagnosis.vue?vue&type=script&lang=js&"
import style0 from "./Diagnosis.vue?vue&type=style&index=0&id=64eebe36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eebe36",
  null
  
)

export default component.exports